import { ProductGroupList } from './ProductGroupList';
import { ProductGroupCreate } from './ProductGroupCreate';
import { ProductGroupEdit } from './ProductGroupEdit';

export default {
    list: ProductGroupList,
    create: ProductGroupCreate,
    edit: ProductGroupEdit,
};
